import SubscriberEditor from './subscriber-editor'

export default SubscriberEditor;
